import React from 'react';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';
import { useDebriefApp } from 'ff/debrief/hooks';
import SidebarPanel from 'ff/debrief/layouts/SidebarPanel';
import SidebarTabs, { MINE } from './SidebarTabs';
import FilterBar from './FilterBar';
import TracklogList from './TracklogList';

const Sidebar = () => {
    const {
        filterStartTimestamp,
        filterEndTimestamp,
        fuzzySearchTerm,
        setFilterStartTimestamp,
        setFilterEndTimestamp,
        setFuzzySearchTerm,
    } = useDebriefApp();

    return (
        <SidebarPanel>
            {isFeatureEnabled('new_share_debrief_feature') && (
                <SidebarTabs currentTab={MINE} />
            )}
            <FilterBar
                startTimestamp={filterStartTimestamp}
                endTimestamp={filterEndTimestamp}
                fuzzySearchTerm={fuzzySearchTerm}
                onStartChange={setFilterStartTimestamp}
                onEndChange={setFilterEndTimestamp}
                onFuzzySearchChange={setFuzzySearchTerm}
            />
            <TracklogList
                startTimestamp={filterStartTimestamp}
                endTimestamp={filterEndTimestamp}
                fuzzySearchTerm={fuzzySearchTerm}
            />
        </SidebarPanel>
    );
};

export default Sidebar;
